import { AiOutlineLeft, AiOutlineRight,AiFillEdit } from 'react-icons/ai';
import PhoneImg from '../assets/images/phone_air.png';
import { BsPhone } from "react-icons/bs";
import { MdCamera } from "react-icons/md";
import { HiChip } from "react-icons/hi";
import { MdBatteryChargingFull } from "react-icons/md";
import { BiSolidMemoryCard } from "react-icons/bi";
import { AllNationsCode } from './countries';
import { motion } from 'framer-motion';
import { useFirebase } from '../utils/useFirebase.ts';
import { useState } from 'react';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from '@nextui-org/react';
import { IoIosColorPalette } from "react-icons/io";


const PreOrderForm = () => {

    const {add, makeUpload} = useFirebase();


    const [ FormStage, setFormStage ] = useState(1)

    const [ orderRam, setorderRam ] = useState('')
    const [ orderStorage, setorderStorage ] = useState('')
    const [ orderColor, setorderColor ] = useState('black')
    const [ UserForm, setUserForm ] = useState({
        full_name:'',
        email:'',
        country:'',
        mobile_number:'',
        kingschat_username:'',
        zone:'',
    })
    const [ Loading, setLoading ] = useState(false)

    const HandleFormSubmit = async () => {

        setLoading(true)

        console.log(UserForm)

        if ( UserForm.full_name === '' ||
             UserForm.email === '' ||
             UserForm.country === '' ||
             UserForm.mobile_number === ''
            //  UserForm.kingschat_username === '' ||
            //  UserForm.zone === ''
               ) {

                toast.error('Please fill all fields', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
        
                setLoading(false)
                return

        }

        try{

            await add({
                col:'orders',
                data:{
                    fullName: UserForm.full_name,
                    email: UserForm.email,
                    country: UserForm.country,
                    mobileNumber: UserForm.mobile_number,
                    kingschatUsername: UserForm.kingschat_username, 
                    zone_church: UserForm.zone,
                    ram: orderRam,
                    rom: orderStorage,
                    color: orderColor
                },
                id:UserForm.email
             });


             toast.success('Your Order was created successfully', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                });

             setUserForm({
                full_name:'',
                email:'',
                country:'',
                mobile_number:'',
                kingschat_username:'',
                zone:'',
            })
            setorderColor('black')
            setorderRam('')
            setorderStorage('')
            setFormStage(1)
            setLoading(false)

        }
        catch(error){
            setLoading(false)
            toast.error('Something went wrong', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            console.log(error)
        }

    }

    const SelectOption = ({size,type,label,placeholder,isSelected,selectRam,selectStorage,value,onChange}) => {


        if ( type === 'ram' ) {
            return (
                <div className={`select_option ${ isSelected ? 'select_option_selected' : '' }`} onClick={selectRam} >
                    <h5>{size}GB</h5>
                    <h6>Choosing {size}GB of RAM is beneficial as it provides ample memory capacity for multitasking, ensuring smoother performance when running multiple applications simultaneously</h6>
                </div>
            );
        }

        if ( type === 'storage' ) {
            return (
                <div className={`select_option ${ isSelected ? 'select_option_selected' : '' }`} onClick={selectStorage} >
                    <h5>{size}GB</h5>
                    <h6>Choosing {size}GB of ROM is beneficial as it provides ample memory capacity for multitasking, ensuring smoother performance when running multiple applications simultaneously</h6>
                </div>
            );
        }

        if ( type === 'input' ) {
            
            return (
                <div className='preorder_section_form_right_input' >
                    <label className='preorder_section_form_right_input_label' >{label}</label>
                    <input className='preorder_section_form_right_input_input' key={label} type='text' placeholder={placeholder} value={value} onChange={onChange} />
                </div>
            );

        }

        if ( type === 'selectbox' ) {
            
            return (
                <div className='preorder_section_form_right_input' >
                    <label className='preorder_section_form_right_input_label' >{label}<span style={{color:"red"}} >*</span></label>
                    <select className='preorder_section_form_right_input_input' value={ UserForm.country } onChange={ (e) => {
                        setUserForm({
                            ...UserForm,
                            country:e.target.value
                        })
                    } } >
                        <option>---Select Country---</option>
                        { AllNationsCode.map( (nation,index) => {
                            return <option value={nation.new_field} key={index} onClick={ () => {
                                setUserForm({
                                    ...UserForm,
                                    country:nation.new_field
                                })
                            } } >{nation.label}</option>
                        } ) }
                    </select>
                </div>
            );

        }

        return

    }

    const SelectColor = ({color,onClick}) => {

        return (
            <div className='preorder_section_form_left_colors_color' onClick={onClick} style={{
                backgroundColor:color,
                border: color === orderColor ? '4px solid #A225F1' : '4px solid transparent'
            }} ></div>
        );

    }

    const LeftDisplay = ({stage}) => {

        if ( stage === 1 ) {
            return <div className='preorder_section_form_right' >

                        <h5 className='preorder_section_form_right_title' >
                            Select your RAM size?
                        </h5>

                        <h5 className='preorder_section_form_right_subtitle' >
                            choose which ram size is best suited for your needs...
                        </h5>

                        <SelectOption size={'4'} type={"ram"} isSelected={ orderRam === '4' ? true : false } selectRam={ () => setorderRam('4') } />
                        <SelectOption size={'6'} type={"ram"} isSelected={ orderRam === '6' ? true : false } selectRam={ () => setorderRam('6') } />
                        <SelectOption size={'8'} type={"ram"} isSelected={ orderRam === '8' ? true : false } selectRam={ () => setorderRam('8') } />

                        <div className='preorder_section_form_right_submit' style={{
                            justifyContent:"flex-end"
                        }} >

                            {/* <button className='preorder_section_form_right_submit_left' >
                                <AiOutlineLeft className='preorder_section_form_right_submit_left_ic' />
                                Previous
                            </button> */}
                            <button className='preorder_section_form_right_submit_right' onClick={ () => {

                                if ( orderRam === '' ) {
                                    return
                                }else{
                                    setFormStage(2)
                                }

                            } } >
                                Next
                                <AiOutlineRight className='preorder_section_form_right_submit_right_ic' />
                            </button>

                        </div>

                    </div>
        }

        if ( stage === 2 ) {
            return <div className='preorder_section_form_right' >

                        <h5 className='preorder_section_form_right_title' >
                            Select your Storage size?
                        </h5>

                        <h5 className='preorder_section_form_right_subtitle' >
                            choose which storage size is best suited for your needs...
                        </h5>

                        <SelectOption size={64} type={"storage"} isSelected={ orderStorage === '64' ? true : false } selectStorage={ () => {
                            setorderStorage('64')
                        } } />
                        <SelectOption size={128} type={"storage"} isSelected={ orderStorage === '128' ? true : false } selectStorage={ () => {
                            setorderStorage('128')
                        } } />
                        <SelectOption size={256} type={"storage"} isSelected={ orderStorage === '256' ? true : false } selectStorage={ () => {
                            setorderStorage('256')
                        } } />

                        <div className='preorder_section_form_right_submit' >

                            <button className='preorder_section_form_right_submit_left' onClick={ () => {
                                setFormStage(1)
                            } } >
                                <AiOutlineLeft className='preorder_section_form_right_submit_left_ic' />
                                Previous
                            </button>
                            <button className='preorder_section_form_right_submit_right' onClick={ () => {
                                if ( orderStorage === '' ) {
                                    return
                                }else{
                                    setFormStage(3)
                                }
                            } } >
                                Next
                                <AiOutlineRight className='preorder_section_form_right_submit_right_ic' />
                            </button>

                        </div>

                    </div>
        }

        if ( stage === 3 ) {
            return <div className='preorder_section_form_right' >

                        <h5 className='preorder_section_form_right_title' >
                            Your Xceptia LDX Specifications
                        </h5>

                        <h5 className='preorder_section_form_right_subtitle' >
                            These are your Xceptia specifications in a nutshell...
                        </h5>

                        <div className='preorder_section_form_right_specs' >
                            <BsPhone className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <h4>6.43"</h4>
                                <h5>1440px x 2960px</h5>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_specs' >
                            <MdCamera className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <h4>48MP Camera</h4>
                                <h5>2960p</h5>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_specs' >
                            <HiChip className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <h4>{orderRam}GB RAM</h4>
                                <h5>Snapdragon 690 <br/> 5G</h5>
                            </div>
                            <div className='preorder_section_form_right_specs_edit' onClick={ () => setFormStage(1) } >
                                <AiFillEdit className='preorder_section_form_right_specs_edit_ic' />
                                <h4>Edit</h4>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_specs' >
                            <BiSolidMemoryCard className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <h4>{orderStorage}GB</h4>
                                <h5>ROM</h5>
                            </div>
                            <div className='preorder_section_form_right_specs_edit' onClick={ () => setFormStage(2) } >
                                <AiFillEdit className='preorder_section_form_right_specs_edit_ic' />
                                <h4>Edit</h4>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_specs' >
                            <IoIosColorPalette className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <div style={{
                                    width:'2rem',
                                    marginBottom:'.5rem',
                                    height:"2rem",
                                    border:"1px solid gray",
                                    borderRadius:'400px',
                                    backgroundColor:orderColor
                                }} ></div>
                                <h5 style={{
                                    textTransform:"uppercase"
                                }} >{orderColor}</h5>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_specs' >
                            <MdBatteryChargingFull className='preorder_section_form_right_specs_ic' />
                            <div className='preorder_section_form_right_specs_detail' >
                                <h4>5000mAh</h4>
                                <h5>Li-Po</h5>
                            </div>
                        </div>

                        <div className='preorder_section_form_right_submit' >

                            <button className='preorder_section_form_right_submit_left' onClick={ () => {
                                if ( orderStorage === '' ) {
                                    return
                                }else{
                                    setFormStage(2)
                                }
                            } } >
                                <AiOutlineLeft className='preorder_section_form_right_submit_left_ic' />
                                Previous
                            </button>
                            <button className='preorder_section_form_right_submit_right' onClick={ () => {
                                setFormStage(4)
                            } } >
                                Confirm
                                <AiOutlineRight className='preorder_section_form_right_submit_right_ic' />
                            </button>

                        </div>

                    </div>

        }

        // if ( stage === 4 ) {
        //     return <div className='preorder_section_form_right' >

        //                 <h5 className='preorder_section_form_right_title' >
        //                     Complete your Xceptia pre-order
        //                 </h5>

        //                 <h5 className='preorder_section_form_right_subtitle' >
        //                     provide your personal details to complete your pre-order...
        //                 </h5>

        //                 <SelectOption
        //                     label={"Full Name"}
        //                     placeholder={"John Issac"}
        //                     type={"input"}
        //                     value={UserForm.full_name}
        //                     onChange={ (e) => setUserForm({
        //                         ...UserForm,
        //                         full_name:e.target.value
        //                     }) }
        //                 />

        //                 <SelectOption
        //                     label={"Email Address"}
        //                     placeholder={"xep123@example.com"}
        //                     type={"input"}
        //                     value={UserForm.email}
        //                     onChange={ (e) => setUserForm({
        //                         ...UserForm,
        //                         email:e.target.value
        //                     }) }
        //                 />

        //                 <SelectOption
        //                     label={"Mobile Number"}
        //                     placeholder={"902455776"}
        //                     type={"input"}
        //                     value={UserForm.mobile_number}
        //                     onChange={ (e) => setUserForm({
        //                         ...UserForm,
        //                         mobile_number:e.target.value
        //                     }) }
        //                 />  

        //                 <SelectOption
        //                     label={"Country"}
        //                     type={"selectbox"}
        //                 />

        //                 <SelectOption
        //                     label={"Kingschat Username"}
        //                     placeholder={"dikins"}
        //                     type={"input"}
        //                     value={UserForm.kingschat_username}
        //                     onChange={ (e) => setUserForm({
        //                         ...UserForm,
        //                         kingschat_username:e.target.value
        //                     }) }
        //                 />

        //                 <SelectOption
        //                     label={"Church / Zone"}
        //                     placeholder={"Blw Zone E"}
        //                     type={"input"}
        //                     value={UserForm.zone}
        //                     onChange={ (e) => setUserForm({
        //                         ...UserForm,
        //                         zone:e.target.value
        //                     }) }
        //                 />

        //                 <button className='preorder_section_form_right_btn' onClick={ () => HandleFormSubmit() } >
        //                     Place Order
        //                 </button>

        //                 <button className='preorder_section_form_right_prv' >
        //                     Cancel Order
        //                 </button>

        //             </div>  

        // }

        return;

    }

    return (

        <section className="preorder_section" id="preorder"  >

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />

            <motion.h4 
                className="preorder_section_title"
                initial={{ letterSpacing:'-0.5em', opacity: 0 }}
                whileInView={{opacity: 1,letterSpacing:'.2em'}}
                transition={{ duration: 0.7 }}
            viewport={{ once: true }}

            >
                <IoIosColorPalette className='preorder_section_title_ic' />

                Customize your Xceptia experience</motion.h4>

            <div className="preorder_section_form" >

                <div className='preorder_section_form_left' >
                    <img src={PhoneImg} className='preorder_section_form_left_img' alt='' />
                    <div className='preorder_section_form_left_selColor' >Select your Xceptia color</div>
                    <div className='preorder_section_form_left_colors' >
                        <SelectColor color={"black"} onClick={ () => setorderColor('black') } />
                        <SelectColor color={"gray"} onClick={ () => setorderColor('gray') } />
                        <SelectColor color={"goldenrod"} onClick={ () => setorderColor('goldenrod') } />
                        <SelectColor color={"white"} onClick={ () => setorderColor('white') } />
                    </div>
                </div>

                <LeftDisplay
                    stage={FormStage}
                />

                { FormStage === 4 ?
                
                
                <div className='preorder_section_form_right' >

                        <h5 className='preorder_section_form_right_title' >
                            Complete your Xceptia pre-order
                        </h5>

                        <h5 className='preorder_section_form_right_subtitle' >
                            provide your personal details to complete your pre-order...
                        </h5>

                        <div className='preorder_section_form_right_input' >
                            <label className='preorder_section_form_right_input_label' >Full Name<span style={{color:"red"}} >*</span></label>
                            <input className='preorder_section_form_right_input_input' type='text' placeholder="John Isaac" value={UserForm.full_name} onChange={ (e) => setUserForm({
                                ...UserForm,
                                full_name:e.target.value
                            }) } />
                        </div>

                        <div className='preorder_section_form_right_input' >
                            <label className='preorder_section_form_right_input_label' >Email Address<span style={{color:"red"}} >*</span></label>
                            <input className='preorder_section_form_right_input_input' type='text' placeholder="xep123@example.com" value={UserForm.email} onChange={ (e) => setUserForm({
                                ...UserForm,
                                email:e.target.value
                            }) } />
                        </div>

                        <div className='preorder_section_form_right_input' >
                            <label className='preorder_section_form_right_input_label' >Mobile Number<span style={{color:"red"}} >*</span></label>
                            <input className='preorder_section_form_right_input_input' type='text' placeholder="+2349028060262" value={UserForm.mobile_number} onChange={ (e) => setUserForm({
                                ...UserForm,
                                mobile_number:e.target.value
                            }) } />
                        </div> 

                        <SelectOption
                            label={"Country"}
                            type={"selectbox"}
                        />

                        <div className='preorder_section_form_right_input' >
                            <label className='preorder_section_form_right_input_label' >Kingschat Username<span style={{color:"gray",marginLeft:'.5rem'}} >(Optional)</span></label>
                            <input className='preorder_section_form_right_input_input' type='text' placeholder="@dikins" value={UserForm.kingschat_username} onChange={ (e) => setUserForm({
                                ...UserForm,
                                kingschat_username:`${e.target.value}`
                            }) } />
                        </div> 

                        <div className='preorder_section_form_right_input' >
                            <label className='preorder_section_form_right_input_label' >Church / Zone<span style={{color:"gray",marginLeft:'.5rem'}} >(Optional)</span></label>
                            <input className='preorder_section_form_right_input_input' type='text' placeholder="BLW Zone K" value={UserForm.zone} onChange={ (e) => setUserForm({
                                ...UserForm,
                                zone:e.target.value
                            }) } />
                        </div>

                        <button className='preorder_section_form_right_btn' onClick={ () => HandleFormSubmit() } >
                            { Loading ? 'Sending...' : 'Place Order' }
                        </button>

                        <button className='preorder_section_form_right_prv' onClick={ () => {
                            setUserForm({
                                full_name:'',
                                email:'',
                                country:'',
                                mobile_number:'',
                                kingschat_username:'',
                                zone:'',
                            })
                            setorderColor('black')
                            setorderRam('')
                            setorderStorage('')
                            setFormStage(1)
                            setLoading(false)
                        } } >
                            Cancel Order
                        </button>

                    </div>  

                
                :<></> }

            </div>

        </section>

    );

}

export default PreOrderForm;